// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__NHTk3","name":"ConsentHeader_name__36z4C","birthday":"ConsentHeader_birthday__2oNaN","skeleton":"ConsentHeader_skeleton__2awTe"};